var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreatingAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 120,
    viewBox: "0 0 296 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12675_6745)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M224.168 64.0705C223.584 70.1373 221.325 76.3637 217.154 82.2524C212.121 89.3571 205.346 100.852 195.556 105.965C162.814 123.063 107.414 122.853 64.8902 109.892C64.2461 109.698 63.6214 109.502 62.995 109.284C62.9152 109.268 62.8335 109.229 62.7537 109.213C56.4025 107.173 50.3519 104.726 44.6762 101.821C35.3947 97.0778 27.1586 91.1934 20.487 84.0357C20.2079 83.7441 19.9483 83.4509 19.6887 83.1577C13.3188 76.0875 8.42139 67.8189 5.52122 58.2863C5.30497 57.5629 5.11005 56.8601 4.91513 56.1574C-2.70116 27.1341 15.4192 1.21576 44.7104 1.69417C71.5048 2.1298 79.1357 13.0945 99.913 20.1314C120.688 27.1459 147.03 21.0804 168.654 18.5477C176.062 17.6721 183.828 18.7661 188.921 19.8318C207.361 23.7359 226.775 36.9603 224.168 64.0705Z",
    fill: "#4182EC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 116.961,
    cy: 116.08,
    rx: 119.621,
    ry: 3.91992,
    fill: "url(#paint0_radial_12675_6745)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 50.2805,
    cy: 116.08,
    rx: 52.9408,
    ry: 3.91992,
    fill: "url(#paint1_radial_12675_6745)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 37.7016,
    cy: 3.91992,
    rx: 37.7016,
    ry: 3.91992,
    transform: "matrix(-1 0 0 1 222.79 112.16)",
    fill: "url(#paint2_radial_12675_6745)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9665 5.19385C15.2909 33.8931 26.0584 75.0248 33.3808 91.6752H54.4624C43.9394 31.9064 32.65 8.89861 27.9665 5.19385Z",
    fill: "url(#paint3_radial_12675_6745)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0365 90.6752H53.27C48.0791 61.457 42.7186 41.1796 38.0793 27.7367C35.7285 20.9248 33.5678 15.8822 31.7156 12.3265C30.3733 9.74957 29.2206 8.00876 28.3095 6.94002C22.62 20.7941 22.2175 37.4571 24.1665 52.827C26.1293 68.3064 30.4614 82.3526 34.0365 90.6752ZM27.5535 6.15294C15.5293 34.8021 26.1396 75.2094 33.3808 91.6752H54.4624C54.4035 91.3408 54.3446 91.0074 54.2857 90.6752C44.3545 34.7003 33.7786 11.3287 28.74 5.92044C28.4654 5.62567 28.2072 5.38426 27.9665 5.19385C27.8259 5.51203 27.6883 5.83174 27.5535 6.15294Z",
    fill: "url(#paint4_linear_12675_6745)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.561 5.19382C39.2634 18.4914 36.3938 64.0944 35.823 85.216H64.0299C65.0373 78.3657 60.2173 16.6781 52.561 5.19382Z",
    fill: "url(#paint5_radial_12675_6745)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.823 85.216H64.0299C65.0138 78.5257 60.4392 19.5289 53.0927 6.07904C52.917 5.75749 52.7398 5.46197 52.561 5.19382C52.3221 5.43279 52.0865 5.68219 51.8542 5.94169C39.3615 19.8986 36.4737 63.0808 35.8512 84.216C35.8413 84.5551 35.8318 84.8885 35.823 85.216ZM36.8517 84.216H63.1177C63.1672 83.3248 63.1768 82.0052 63.1406 80.3031C63.0906 77.9562 62.9559 74.9541 62.7415 71.4995C62.3127 64.5912 61.567 55.8965 60.5509 47.0568C59.5345 38.2146 58.2495 29.2435 56.7444 21.7765C55.9917 18.0424 55.1869 14.6991 54.3377 11.943C53.6934 9.85222 53.0356 8.14037 52.3763 6.86215C49.614 10.0596 47.2931 14.8399 45.3652 20.6518C43.2411 27.0552 41.6284 34.6031 40.4075 42.4251C38.0439 57.5685 37.1639 73.6403 36.8517 84.216Z",
    fill: "url(#paint6_linear_12675_6745)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9744 85.7327H67.3969L61.5686 111.179C60.8985 114.105 58.2954 116.179 55.2939 116.179H37.0774C34.0759 116.179 31.4728 114.105 30.8027 111.179L24.9744 85.7327Z",
    fill: "url(#paint7_linear_12675_6745)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9744 85.7327L30.8027 111.179C31.4728 114.105 34.0759 116.179 37.0774 116.179H55.2939C58.2954 116.179 60.8985 114.105 61.5686 111.179L67.3969 85.7327H24.9744ZM26.2293 86.7327L31.7775 110.956C32.3435 113.427 34.5422 115.179 37.0774 115.179H55.2939C57.8291 115.179 60.0278 113.427 60.5938 110.956L66.142 86.7327H26.2293Z",
    fill: "url(#paint8_linear_12675_6745)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1096 82.0194C22.1096 81.4269 22.5899 80.9465 23.1824 80.9465H69.1876C69.7801 80.9465 70.2605 81.4269 70.2605 82.0194V85.8693C70.2605 86.4619 69.7801 86.9422 69.1876 86.9422H23.1824C22.5899 86.9422 22.1096 86.4619 22.1096 85.8693V82.0194Z",
    fill: "url(#paint9_linear_12675_6745)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1876 81.9465H23.1824C23.1422 81.9465 23.1096 81.9792 23.1096 82.0194V85.8693C23.1096 85.9096 23.1422 85.9422 23.1824 85.9422H69.1876C69.2278 85.9422 69.2605 85.9096 69.2605 85.8693V82.0194C69.2605 81.9792 69.2278 81.9465 69.1876 81.9465ZM23.1824 80.9465C22.5899 80.9465 22.1096 81.4269 22.1096 82.0194V85.8693C22.1096 86.4619 22.5899 86.9422 23.1824 86.9422H69.1876C69.7801 86.9422 70.2605 86.4619 70.2605 85.8693V82.0194C70.2605 81.4269 69.7801 80.9465 69.1876 80.9465H23.1824Z",
    fill: "url(#paint10_linear_12675_6745)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.7 113.499L104.799 96.7886H130.245L134.741 113.451C135.112 114.827 134.076 116.18 132.651 116.18H102.803C101.398 116.18 100.365 114.863 100.7 113.499Z",
    fill: "url(#paint11_linear_12675_6745)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.583 97.7886L101.671 113.737C101.491 114.471 102.047 115.18 102.803 115.18H132.651C133.418 115.18 133.975 114.451 133.776 113.711L129.479 97.7886H105.583ZM104.799 96.7886L100.7 113.499C100.365 114.863 101.398 116.18 102.803 116.18H132.651C134.076 116.18 135.112 114.827 134.741 113.451L130.245 96.7886H104.799Z",
    fill: "url(#paint12_linear_12675_6745)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2185 17.9285C54.2185 13.1179 58.1182 9.21826 62.9287 9.21826H172.591C177.402 9.21826 181.301 13.1179 181.301 17.9285V91.1741C181.301 95.9846 177.402 99.8843 172.591 99.8843H62.9287C58.1182 99.8843 54.2185 95.9846 54.2185 91.1741V17.9285Z",
    fill: "url(#paint13_linear_12675_6745)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.591 10.2183H62.9287C58.6705 10.2183 55.2185 13.6702 55.2185 17.9285V91.1741C55.2185 95.4323 58.6705 98.8843 62.9287 98.8843H172.591C176.849 98.8843 180.301 95.4323 180.301 91.1741V17.9285C180.301 13.6702 176.849 10.2183 172.591 10.2183ZM62.9287 9.21826C58.1182 9.21826 54.2185 13.1179 54.2185 17.9285V91.1741C54.2185 95.9846 58.1182 99.8843 62.9287 99.8843H172.591C177.402 99.8843 181.301 95.9846 181.301 91.1741V17.9285C181.301 13.1179 177.402 9.21826 172.591 9.21826H62.9287Z",
    fill: "url(#paint14_linear_12675_6745)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1807 17.9995C59.1807 15.7904 60.9716 13.9995 63.1807 13.9995H172.339C174.548 13.9995 176.339 15.7904 176.339 17.9995V23.8678H59.1807V17.9995Z",
    fill: "url(#paint15_linear_12675_6745)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.859 46.0854C134.187 47.0013 133.466 47.9102 132.493 47.9102H124.248C123.414 47.9102 122.737 47.2336 122.737 46.399L122.737 44.5765C122.737 42.6964 120.58 41.6336 119.089 42.779L109.587 50.0796C108.406 50.987 108.406 52.7673 109.587 53.6747L119.089 60.9753C120.58 62.1208 122.737 61.0579 122.737 59.1778L122.737 56.9775C122.737 56.1429 123.414 55.4663 124.248 55.4663H132.493C133.466 55.4663 134.187 56.3752 133.859 57.2911C131.56 63.7153 125.418 68.3116 118.204 68.3116C109.023 68.3116 101.58 60.8691 101.58 51.6883C101.58 42.5075 109.023 35.0649 118.204 35.0649C125.418 35.0649 131.56 39.6612 133.859 46.0854Z",
    fill: "url(#paint16_linear_12675_6745)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12675_6745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2185 84.9489H181.301V91.1751C181.301 95.9856 177.402 99.8852 172.591 99.8852H62.9287C58.1182 99.8852 54.2185 95.9855 54.2185 91.175V84.9489Z",
    fill: "url(#paint17_linear_12675_6745)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_12675_6745)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.301 85.9489H55.2185V91.175C55.2185 95.4333 58.6705 98.8852 62.9287 98.8852H172.591C176.849 98.8852 180.301 95.4333 180.301 91.1751V85.9489ZM54.2185 84.9489V91.175C54.2185 95.9855 58.1182 99.8852 62.9287 99.8852H172.591C177.402 99.8852 181.301 95.9856 181.301 91.1751V84.9489H54.2185Z",
    fill: "url(#paint18_linear_12675_6745)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 117.76,
    cy: 92.417,
    r: 3.27568,
    fill: "url(#paint19_radial_12675_6745)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.631 81.1157C171.24 81.1157 170.923 81.4325 170.923 81.8233V109.811C170.923 113.328 173.774 116.179 177.291 116.179H199.397C202.914 116.179 205.765 113.328 205.765 109.811V108.947H207.907C213.779 108.947 218.539 104.187 218.539 98.3149C218.539 92.4429 213.779 87.6826 207.907 87.6826H205.765V81.8233C205.765 81.4325 205.448 81.1157 205.057 81.1157H171.631ZM205.765 104.429V92.2012H207.907C211.283 92.2012 214.02 94.9384 214.02 98.3149C214.02 101.691 211.283 104.429 207.907 104.429H205.765Z",
    fill: "url(#paint20_radial_12675_6745)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.923 82.1157V109.811C171.923 112.776 174.326 115.179 177.291 115.179H199.397C202.361 115.179 204.765 112.776 204.765 109.811V82.1157H171.923ZM171.631 81.1157C171.24 81.1157 170.923 81.4325 170.923 81.8233V109.811C170.923 113.328 173.774 116.179 177.291 116.179H199.397C202.914 116.179 205.765 113.328 205.765 109.811V81.8233C205.765 81.4325 205.448 81.1157 205.057 81.1157H171.631Z",
    fill: "url(#paint21_linear_12675_6745)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.768 104.427H208.023H208.584L209.183 104.298L209.731 104.179L210.278 103.976V108.672L209.177 108.87L208.023 108.959H205.768V104.427Z",
    fill: "url(#paint22_linear_12675_6745)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.768 92.2061H208.023H208.584L209.183 92.3358L209.731 92.4545L210.278 92.658V87.9613L209.177 87.7635L208.023 87.6749H205.768V92.2061Z",
    fill: "url(#paint23_linear_12675_6745)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.0488,
    cy: 18.9331,
    r: 2.04883,
    fill: "#9FB5E1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.6814,
    cy: 18.9331,
    r: 2.04883,
    fill: "#9FB5E1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.314,
    cy: 18.9331,
    r: 2.04883,
    fill: "#9FB5E1"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_12675_6745)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.768,
    y: 20,
    width: 45,
    height: 19.35,
    rx: 4,
    fill: "url(#paint24_linear_12675_6745)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.768,
    y: 24,
    width: 11.35,
    height: 11.35,
    rx: 2.05381,
    fill: "url(#paint25_linear_12675_6745)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.507 27.4182C168.507 28.485 169.375 29.3532 170.442 29.3532C171.509 29.3532 172.377 28.485 172.377 27.4182C172.377 26.3514 171.509 25.4832 170.442 25.4832C169.375 25.4832 168.507 26.3514 168.507 27.4182ZM173.882 33.6532H174.312V33.2232C174.312 31.5638 172.961 30.2132 171.302 30.2132H169.582C167.922 30.2132 166.572 31.5638 166.572 33.2232V33.6532H173.882Z",
    fill: "url(#paint26_radial_12675_6745)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.118,
    y: 25.5705,
    width: 23.65,
    height: 2.82086,
    rx: 1.02691,
    fill: "url(#paint27_linear_12675_6745)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.118,
    y: 30.9586,
    width: 10.4066,
    height: 2.82086,
    rx: 1.02691,
    fill: "url(#paint28_linear_12675_6745)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_12675_6745)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.768,
    y: 41,
    width: 45,
    height: 19.35,
    rx: 4,
    fill: "url(#paint29_linear_12675_6745)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.768,
    y: 45,
    width: 11.35,
    height: 11.35,
    rx: 2.05381,
    fill: "url(#paint30_linear_12675_6745)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.507 48.4182C168.507 49.485 169.375 50.3532 170.442 50.3532C171.509 50.3532 172.377 49.485 172.377 48.4182C172.377 47.3514 171.509 46.4832 170.442 46.4832C169.375 46.4832 168.507 47.3514 168.507 48.4182ZM173.882 54.6532H174.312V54.2232C174.312 52.5638 172.961 51.2132 171.302 51.2132H169.582C167.922 51.2132 166.572 52.5638 166.572 54.2232V54.6532H173.882Z",
    fill: "url(#paint31_radial_12675_6745)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.118,
    y: 46.5705,
    width: 16.3349,
    height: 2.82086,
    rx: 1.02691,
    fill: "url(#paint32_linear_12675_6745)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.118,
    y: 51.9586,
    width: 23.65,
    height: 2.82086,
    rx: 1.02691,
    fill: "url(#paint33_linear_12675_6745)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12675_6745",
    x: 51.2185,
    y: 82.9489,
    width: 133.083,
    height: 20.9363,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.489389 0 0 0 0 0.552981 0 0 0 0 0.732535 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12675_6745"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12675_6745",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_12675_6745",
    x: 51.2185,
    y: 82.9489,
    width: 133.083,
    height: 20.9363,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.489389 0 0 0 0 0.552981 0 0 0 0 0.732535 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12675_6745"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12675_6745",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_12675_6745",
    x: 158.77,
    y: 19.0007,
    width: 52.9942,
    height: 27.3442,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.99856,
    dy: 2.99784
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.99856
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.130752 0 0 0 0 0.15853 0 0 0 0 0.219642 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12675_6745"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12675_6745",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_12675_6745",
    x: 158.77,
    y: 40.0007,
    width: 52.9942,
    height: 27.3442,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.99856,
    dy: 2.99784
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.99856
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.130752 0 0 0 0 0.15853 0 0 0 0 0.219642 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12675_6745"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12675_6745",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_12675_6745",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(116.961 116.08) rotate(90) scale(3.91992 119.621)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7988B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864583,
    stopColor: "#7988B1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_12675_6745",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.2805 116.08) rotate(90) scale(3.91992 52.9408)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7988B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864583,
    stopColor: "#7988B1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_12675_6745",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.7016 3.91992) rotate(90) scale(3.91992 37.7016)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7988B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864583,
    stopColor: "#7988B1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_12675_6745",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.1093 24.1995) rotate(12.011) scale(15.7698 96.2761)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6FFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A172"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12675_6745",
    x1: 22.1093,
    y1: 41.3315,
    x2: 47.9362,
    y2: 42.6096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDFFDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#257169"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_12675_6745",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.823 66.5393) rotate(-0.0759046) scale(18.1934 117.313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6FFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662167,
    stopColor: "#63A894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#368979"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12675_6745",
    x1: 38.2978,
    y1: 54.4465,
    x2: 56.6111,
    y2: 57.2016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#256F67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12675_6745",
    x1: 67.3969,
    y1: 85.7327,
    x2: 31.4434,
    y2: 113.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F1818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827611,
    stopColor: "#B98888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12675_6745",
    x1: 60.0067,
    y1: 119.321,
    x2: 19.3728,
    y2: 87.8596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#642C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401832,
    stopColor: "#804A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B78686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_12675_6745",
    x1: 23.8187,
    y1: 81.612,
    x2: 29.3268,
    y2: 96.1032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0403995,
    stopColor: "#DCB3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557163,
    stopColor: "#B28080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#874D4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_12675_6745",
    x1: 33.6423,
    y1: 98.3359,
    x2: 24.4304,
    y2: 77.5639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3B9B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_12675_6745",
    x1: 127.875,
    y1: 96.7886,
    x2: 117.76,
    y2: 121.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7284AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482806,
    stopColor: "#C0CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747761,
    stopColor: "#D3DFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE6F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_12675_6745",
    x1: 117.76,
    y1: 96.7886,
    x2: 117.76,
    y2: 116.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_12675_6745",
    x1: 65.3588,
    y1: 2.80079,
    x2: 191.352,
    y2: 63.3531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#425892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404281,
    stopColor: "#2E3D75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09143F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_12675_6745",
    x1: 51.4874,
    y1: 0.995655,
    x2: 176.93,
    y2: 89.3836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7592EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091E59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_12675_6745",
    x1: 53.6297,
    y1: 15.3467,
    x2: 62.9223,
    y2: 48.9395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273E7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#162443"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_12675_6745",
    x1: 176.936,
    y1: 32.025,
    x2: 22.5656,
    y2: 32.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243986,
    stopColor: "white",
    stopOpacity: 0.648705
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5189,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_12675_6745",
    x1: 58.6455,
    y1: 99.8852,
    x2: 181.301,
    y2: 99.8852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#E5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934523,
    stopColor: "#7385B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_12675_6745",
    x1: 117.76,
    y1: 84.9489,
    x2: 117.76,
    y2: 99.8852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_12675_6745",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(117.76 92.417) rotate(90) scale(8.37708)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5572CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475C9C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_12675_6745",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(172.442 84.0653) rotate(35.9566) scale(39.2961 50.7498)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9C8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E53725"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_12675_6745",
    x1: 205.765,
    y1: 114.736,
    x2: 179.412,
    y2: 81.1157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A22415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#F94834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB8AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_12675_6745",
    x1: 205.768,
    y1: 108.959,
    x2: 211.983,
    y2: 108.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C0D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377771,
    stopColor: "#AC2416"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640109,
    stopColor: "#E53725"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_12675_6745",
    x1: 205.768,
    y1: 87.6749,
    x2: 211.983,
    y2: 87.6749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C0D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377771,
    stopColor: "#B32A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67895,
    stopColor: "#E63D2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_12675_6745",
    x1: 210.264,
    y1: 30.8994,
    x2: 163.011,
    y2: 13.8006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3957B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513908,
    stopColor: "#5473C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#709AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_12675_6745",
    x1: 172.689,
    y1: 45.5212,
    x2: 138,
    y2: 32.9445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D7FCA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_12675_6745",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170.442 29.5682) rotate(90) scale(10.4468 9.89698)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5572CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_12675_6745",
    x1: 194.622,
    y1: 30.9192,
    x2: 186.636,
    y2: 6.64206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D7FCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_12675_6745",
    x1: 185.38,
    y1: 36.3074,
    x2: 172.478,
    y2: 19.0494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D7FCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_12675_6745",
    x1: 210.264,
    y1: 51.8994,
    x2: 163.011,
    y2: 34.8006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3957B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513908,
    stopColor: "#5473C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#709AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_12675_6745",
    x1: 172.689,
    y1: 66.5212,
    x2: 138,
    y2: 53.9445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D7FCA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_12675_6745",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170.442 50.5682) rotate(90) scale(10.4468 9.89698)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5572CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475C9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_12675_6745",
    x1: 189.518,
    y1: 51.9192,
    x2: 179.072,
    y2: 29.9897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D7FCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_12675_6745",
    x1: 194.622,
    y1: 57.3074,
    x2: 186.636,
    y2: 33.0302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D7FCA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12675_6745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 296,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatingAccount);
export default __webpack_public_path__ + "static/media/creating-account.06510955f150fa86e81f86e3c18a0a9a.svg";
export { ForwardRef as ReactComponent };